export const BLOGS_TYPE = {
    event: 'EVENT',
    project: 'PROJECT',
    travel: 'TRAVELING',
    video: 'VIDEO',
}

export const BLOGS_TYPE_PATHS = {
    EVENT: "event",
    PROJECT: "project",
    TRAVELING: "travel",
    VIDEO: "video",
}

export const BADGES_TYPE = {
    EVENT: {
        key: 'EVENT',
        staticKey: 'badge_event',
        bgColor: '#F8C244',
        textColor: "black"
    },
    PROJECT: {
        key: 'PROJECT',
        staticKey: 'badge_project',
        bgColor: '#9160E5',
        textColor: "white"
    },
    TRAVELING: {
        key: 'TRAVELING',
        staticKey: 'badge_traveling',
        bgColor: '#0099F7',
        textColor: "white"
    },
    VIDEO: {
        key: 'VIDEO',
        staticKey: 'badge_video',
        bgColor: '#E54445',
        textColor: "white"
    },
}


export const PAGE_NEWS_COUNT = 12
export const PAGE_GET_COUNT = 6